module.exports = __webpack_public_path__ + "img/collect-a.9c620fb0.png";